/**
 * Format date to a year string representation
 * @param date - input date to format
 */
export const formatYear = (date: Date) => date.getFullYear().toString();
